module.exports = __webpack_public_path__ + "img/81.0060af57.jpg";